import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE015_Request,
  IAPI_PRE015_Response,
} from "../../../type/apiType";

// 掛金納付対象職員届提出についての申請状態取得
const httpAPI_PRE015 = async (
  param: IAPI_PRE015_Request
): Promise<IAPI_PRE015_Response> => {
  let res = await http.post(ApiUrl.API_PRE015, {
    ...param,
  });
  return res.data;
};

export { httpAPI_PRE015 };
